import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// 🔑 IMPORT 1: AuthProvider to provide context state
import { AuthProvider } from './AuthContext'; 
// 🔑 IMPORT 2: BrowserRouter for routing 
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 🛑 WRAPPER FIX: AuthProvider must be higher than components using useAuth() 🛑 */}
    <AuthProvider>
      {/* BrowserRouter must wrap App to enable routing */}
      <BrowserRouter> 
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
